export const HEADERLIST = {
  TOKENO: "TOKEN NUMBER",
  PATIENTNAME: "PATIENT NAME",
  STATUS: "STATUS",
  PROFILESHAREDON: "PROFILE SHARED ON",
};

export const ABHA_STATUS = [
  {
    name: "TOKEN ACTIVE",
    color: "#10A74A",
    backgroundColor: "#CFEDDB",
  },
  {
    name: "TOKEN EXPIRED",
    color: "#FFB400",
    backgroundColor: "#FFB40033",
  },
];

// temp array
export const ABHA_TOKEN_LIST = [
  {
    token_no: 1,
    name: "Himanshu Rajput",
    status: "TOKEN ACTIVE",
  },
  {
    token_no: 2,
    name: "Govind Singh",
    status: "TOKEN EXPIRED",
  },
  {
    token_no: 3,
    name: "Sourav Rajput",
    status: "TOKEN ACTIVE",
  },
  {
    token_no: 4,
    name: "Seema ",
    status: "TOKEN EXPIRED",
  },
  {
    token_no: 5,
    name: "Kittu ",
    status: "TOKEN ACTIVE",
  },
];

// temp arrays
